import React, { useEffect, useState } from 'react'
import { AthleteDTO } from '../../../interfaces/AthletesDTO'
import { TimeDTO } from '../../../interfaces/TimeDTO';
import { eventBus } from '../../../services/eventHandler';
import { useFavorites } from '../../../services/FavoritesProvider';
import { GetDifffromNow, formatDateTime, formatTime } from '../../../services/timeHandler';

interface Props{
    athlete: AthleteDTO;
tim?:TimeDTO;
sortParameter: number;
className:string;
}

const SpeakerViewRow = ({athlete,tim,sortParameter,className}:Props) => {
    const [isFavorite,setIsFavoirte] = useState<boolean>(false);
    const { favorites, addFavorite, removeFavorite } = useFavorites();
   const afterShootnr  = 0;
   const [timeFormat, setTimeFormat] = useState("T");
   const StatusOkay: string[] = ["OK", "ENT", "START", "LL", "REMOVELL"];
   const isRelay = false;
   const [markPassing,setMarkPassing] = useState<boolean>(false);
    useEffect(() => {
        favorites.some((fav) => fav === athlete.ID)
        
    },[]);

    useEffect(() => {
      // setHTMLContent(updateContent);
      if (tim) {
        let tDif = GetDifffromNow(tim.PassTime);
        const redDelaySecond = 20;
        if (tDif / 1000 < redDelaySecond) {
          setMarkPassing(true);
          const timeoutId = setTimeout(() => {
            setMarkPassing(false);
          }, redDelaySecond * 1000 - tDif / 1000);
          // Clear the timeout when the component is unmounted
          return () => clearTimeout(timeoutId);
        }
      }
    }, [tim]);

    const handleClick = () => {
        eventBus.emit(`selctedathlete`, athlete);
        let styleElement = document.getElementById("web-selected-style");
        // adjustWidth();
        if (styleElement) {
          styleElement.textContent = `[data-athleteid="${athlete.ID}"] { background: rgb(128 128 128 / 40%)  !important; }`;
        }
    }
    const commonJSX: JSX.Element = (
        <>
          <div className="resultrowdata resultrowbib clbib">
            <span>{athlete.Startno}</span>
          </div>
          <div className="resultrowdata resultrowshortname clshortname">
            <span>{isRelay ? athlete.FormatedName : athlete.FormatedShortName}</span>
          </div>
          <div className="resultrowdata resultrowname clname">
            <span>{athlete.FormatedName}</span>
          </div>
          <div className="resultrowdata resultrowflag clflag">
            <span
              style={{
                backgroundImage: `url(../../../img/flags/${athlete.Nation}.png)`,
              }}
            >
              &nbsp;
            </span>
          </div>
          <div className="resultrowdata resultrowteam clteam">
            <span>{ athlete.Club}</span>
          </div>
          
          <div className="resultrowdata resultrowrelay clrelay">
            <span>&nbsp;</span>
          </div>
          <div className="resultrowdata resultrowshooting clshootingstring">
            <span>&nbsp;</span>
          </div>
          <div
            className="resultrowdata resultrowshooting clshooting"
            style={
              afterShootnr === 0 ? { display: "none" } : { display: "table-cell" }
            }
          >
            <span>{0}</span>
          </div>
        </>
      );
      if (tim){
        return (
          <div
          style={{ order: sortParameter }}
          className={
            "resultrow " +
            (isFavorite ? "result-row-favorite" : undefined) +
            (markPassing ? " row_last-passed " : undefined)
      
          }
          data-bib={athlete.Startno}
          data-athleteid={athlete.ID}
          data-status={athlete.Status}
          data-rank= {StatusOkay.includes(athlete.Status) ? tim.RankClass : "99999"}
          onClick={handleClick}
        >
           <div
                className="resultrowdata-inner-row-top"
                id={"resin" + athlete.Startno}
              >
                <div
                  className="resultrowdata-inner-inner-row-top"
                  id={"resinin" + athlete.Startno}
                >
          <div className="resultrowdata resultrowrank clrank">
                    <span>
                      {StatusOkay.includes(athlete.Status) ? tim.RankClass : ""}
                    </span>
                  </div>
          {commonJSX}
          <div className="resultrowdata resultrowruntime clruntime">
                    <span>
                      {StatusOkay.includes(athlete.Status)
                        ? formatTime(tim.RunTime, timeFormat)
                        : athlete.Status}
                    </span>
                  </div>
                  <div className="resultrowdata resultrowdiff cldifftime">
                    <span>
                      {StatusOkay.includes(athlete.Status)
                        ? formatTime(tim.DiffClass, timeFormat)
                        : ""}
                    </span>
                  </div>
                    <div className="resultrowdata clclass">
                    <span>{ className}</span>
                  </div>
                  </div>
                  </div>
          </div>
        )
      }
      return (
<div
          style={{ order: sortParameter }}
          className={
            "resultrow " +
            (isFavorite ? "result-row-favorite" : undefined) +
            (markPassing ? " row_last-passed " : undefined)
      
          }
          data-bib={athlete.Startno}
          data-athleteid={athlete.ID}
          data-status={athlete.Status}
          data-rank= { "99999"}
          onClick={handleClick}
        >
           <div
                className="resultrowdata-inner-row-top"
                id={"resin" + athlete.Startno}
              >
                <div
                  className="resultrowdata-inner-inner-row-top"
                  id={"resinin" + athlete.Startno}
                >
          <div className="resultrowdata resultrowrank clrank">
                    <span>
                    &nbsp;
                    </span>
                  </div>
          {commonJSX}
          <div className="resultrowdata resultrowruntime clruntime">
                    <span>
                      {StatusOkay.includes(athlete.Status)
                        ? formatDateTime(athlete.StartTime, "S")
                        : athlete.Status}
                    </span>
                  </div>
                  <div className="resultrowdata resultrowdiff cldifftime">
                    <span>
                      {StatusOkay.includes(athlete.Status)
                        ? ""
                        : athlete.Status}
                    </span>
                  </div>
                    <div className="resultrowdata clclass">
                    <span>{ className}</span>
                  </div>
                  </div>
                  </div>
          </div>
      )
  
}

export default SpeakerViewRow